import _ReplySubmitButton from '../_internal/components/ReplySubmitButton';
import _ReplySubmitButtonGroup from '../_internal/components/ReplySubmitButtonGroup';
export const ReplySubmitButton = _ReplySubmitButton;
export const ReplySubmitButtonGroup = _ReplySubmitButtonGroup;